<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <EXCMAgreementDeviceForm
                  :type="1"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
        </b-col>
      </b-row>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<router-link :to="{ name: 'EXCMAgreementDeviceList' }" class="btn btn-default">Back to list</router-link>-->
        <!--</b-col>-->
      <!--</b-row>-->
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMAgreementDeviceForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmagreementdevice/create')

export default {
  components: {
    EXCMAgreementDeviceForm
  },

  props: {
    agreementIRI: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: this.$t('notifications.created'),
          type: 'success'
        })
        this.$store.state.modals.excmagreementdevice.create.created = 1
        this.$store.state.modals.excmagreementdevice.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMAgreementDeviceUpdate', params: { id: created['@id'] } })
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementIRI) {
      this.item.agreement = this.agreementIRI
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
